export const MAX_OPAQUE_CRM_CURSOR_LENGTH = 2_048;

export function isBoundedOpaqueCrmCursor(value: unknown): value is string {
  return (
    typeof value === "string" &&
    value.length >= 1 &&
    value.length <= MAX_OPAQUE_CRM_CURSOR_LENGTH &&
    !/[\u0000-\u001f\u007f]/.test(value)
  );
}
